module.exports = __webpack_public_path__ + "img/img36.cd1e4bc8.png";